import { Component, Output, EventEmitter, Input, TemplateRef, viewChild } from '@angular/core';
import { IrisButtonTypes } from '@sondermind/iris/button';

@Component({
  selector: 'client-insurance-verification-failed',
  templateUrl: './insurance-verification-failed.component.html',
  styleUrls: ['./insurance-verification-failed.component.scss'],
  standalone: false
})
export class InsuranceVerificationFailedComponent {
  @Input() isMobile: boolean;
  @Input() fromDirectBooking: boolean = false;

  @Output() closeReview: EventEmitter<void> = new EventEmitter<void>();

  // Template for the action button that parent component can render
  readonly actionButtonTemplate = viewChild.required<TemplateRef<unknown>>('actionButton');

  IrisButtonTypes = IrisButtonTypes;

  confirm(): void {
    this.closeReview.emit();
  }
}
